import http from "./apiClient";

export const listNoctisEvents = async ({ since, limit } = {}) => {
  const params = {};
  if (since) params.since = since;
  if (limit != null) params.limit = limit;
  params.includeErrors = true;
  const res = await http.get("/noctis/events", { params });
  return res?.data;
};
